import request from '@/utils/request'

// 查询
export function findAllList (data) {
  return request.post('/system/dictData/findAllList', data)
}
export function createCoffeeTask (data) {
  return request.post('/system/dictData/createCoffeeTask')
}


